import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import { ChartBar } from "./chart";
import '../../style.css';
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Documents {
    data: {
        perStatus: {
            statusCount: string;
            status: string;
        }[];
    };
}

export const ChartStatusDocuments = () => {
    const { changeVisibility } = useContext(LoadingContext);
    const { reloadComponent } = useContext(DashboardContext);
    const { shortToken , id, mode } = useParams();
    const { hasShortToken} = useContext(AuthContext);  

    let routeDocuments: string;
    const [documents, setDocuments] = useState<Documents["data"]>({
        perStatus: [{ statusCount: "", status: "" }]
    });
    const [completeRequisition, setCompleteRequisition] = useState(false);

    if (hasShortToken) {
        routeDocuments = `/documents?graphic_id=chartStatusDocuments&short_token=${shortToken}&screen_id=${id}`;
    } else {
        routeDocuments = `/documents?graphic_id=chartStatusDocuments&screen_id=${id}`;
    }

    useEffect(() => {
        changeVisibility(true);
        const fetchData = async () => {
            try {
                await requisition();
            } finally {
                changeVisibility(false);
                setCompleteRequisition(true);
            }
        };
        fetchData();
        if (mode === "view") {
            const intervalId = setInterval(() => {
                requisition();
            }, 60000);
            return () => clearInterval(intervalId);
        }
    }, []);

    async function requisition() {
        return await api
        .get(routeDocuments)
        .then((documents: Documents) => {
            setDocuments(documents.data);
            
        })
        .catch((error) => {
            errorTreatment(error);
        });
    }

    return completeRequisition && !reloadComponent ? (
        <div id="chart-status-documents" className="h100">
            <ChartBar data={documents} />
        </div>
    ) : ( 
        <></>
    );
};